import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { lifo_navigation } from '../EmaSystemsComponentsV1_0_0/model/interface-system';
@Component({
  selector: 'app-acceso-denegado',
  templateUrl: './acceso-denegado.component.html',
  styleUrls: ['./acceso-denegado.component.scss']
})
export class AccesoDenegadoComponent implements OnInit {
  defaultURL = '';
  constructor(private router: Router, private location: Location,

  ) {
    this.navigation_lifo = JSON.parse(localStorage.getItem("lifo-navigation"));
    let item_lifo = {} as lifo_navigation;
    item_lifo.id = 999;
    item_lifo.page_desc = "Acceso Denegado";
    item_lifo.path = "acceso-denegado";
    let index_ = this.navigation_lifo.findIndex((x) => x.id == item_lifo.id);
    if (index_ >= 0) {
      this.navigation_lifo[index_] = item_lifo;
    } else {
      this.navigation_lifo.push(item_lifo);
    }
    localStorage.setItem(
      "lifo-navigation",
      JSON.stringify(this.navigation_lifo)
    );
  }
navigation_lifo: lifo_navigation[] = [];
goTo(route: string) {
  this.router.navigate([route]);
}
  ngOnInit() {
    let menuTemp = JSON.parse(sessionStorage.getItem('menu'));

    this.defaultURL = menuTemp.defaultURL;
  }
  backMenu(){
    this.navigation_lifo.pop(); ///sacar la última página
    localStorage.setItem(
      "lifo-navigation",
      JSON.stringify(this.navigation_lifo)
    );
    this.goTo(
      "/" + this.navigation_lifo[this.navigation_lifo.length - 1].path
    );
  }

}
